import { render, staticRenderFns } from "./KeyLogsTable.vue?vue&type=template&id=2751e450&"
import script from "./KeyLogsTable.vue?vue&type=script&lang=ts&"
export * from "./KeyLogsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports